// extracted by mini-css-extract-plugin
module.exports = {"header":"Leads_header__3L2X3","title":"Leads_title__ddZXw","form":"Leads_form__32_5u","cancelInfo":"Leads_cancelInfo__13Xma","titleWrapper":"Leads_titleWrapper__3Rp2r"};